import { MenuItem, MenuItemProps, Select, SelectProps } from '@mui/material';
import { HTMLAttributes, PropsWithChildren } from 'react';
import styles from './Dropdown.module.scss';
import { classes } from '../../../lib/utils/cssUtils';
import { LeftArrow } from '../../../lib/icons/LeftArrow';

export type DropdownProps<T> = PropsWithChildren<
  Omit<SelectProps<T>, 'variant'> & { variant?: 'primary' | 'secondary' }
>;
export type DropdownItemProps = PropsWithChildren<MenuItemProps>;

export const DropdownArrow = (props: HTMLAttributes<HTMLOrSVGElement>) => <LeftArrow {...props} />;

const Dropdown = <T extends unknown>({
  children,
  classes: dropdownClasses,
  className,
  variant = 'primary',
  MenuProps,
  ...props
}: DropdownProps<T>) => (
  <Select
    IconComponent={DropdownArrow}
    className={classes(styles.selectRoot, className, variant === 'secondary' && styles.secondary)}
    classes={{
      select: styles.selectInput,
      icon: styles.arrowIcon,
      iconOpen: styles.arrowIconOpened,
      ...dropdownClasses,
    }}
    MenuProps={{
      ...MenuProps,
      classes: {
        paper: classes(styles.optionItemsContainer, MenuProps?.classes?.paper),
        list: styles.optionList,
      },
      disableScrollLock: true,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    }}
    {...props}
  >
    {children}
  </Select>
);

export const DropdownItem = ({ children, classes: dropdownItemClasses, className, ...props }: DropdownItemProps) => (
  <MenuItem
    classes={{ selected: styles.selectedItem, ...dropdownItemClasses }}
    className={classes(styles.selectItem, className)}
    {...props}
  >
    {children}
  </MenuItem>
);

export default Dropdown;
